export interface JSONHandlerResults {
  status?: string;
  data?: any;
  error?: string;
}

